import { Upload } from 'antd';
import { Upload as UploadIcon } from 'lucide-react';

/** Picking a file previews it at once — there is no separate "upload" step before the diff shows. */
export function RateLineImportDropzone({ onChoose }: { onChoose: (file: File) => void }) {
  return (
    <Upload.Dragger
      accept=".xlsx"
      showUploadList={false}
      beforeUpload={(file) => {
        onChoose(file);
        return false;
      }}
    >
      <p className="flex flex-col items-center gap-2 py-6 text-sm text-muted">
        <UploadIcon className="size-6" />
        Drop a .xlsx file here, or click to choose one
      </p>
    </Upload.Dragger>
  );
}
